var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_593_1052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 35,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 57.5835H59V59H25V57.5835ZM59 35.6927V37.7523H54.75V51.9174H57.5833V53.334H26.4167V51.9174H29.25V37.7523H25V35.6927C25 34.0708 25.901 32.6146 27.3502 31.8908L40.2646 25.44C41.3441 24.8522 42.6545 24.8507 43.7567 25.4513L56.6497 31.8894C58.099 32.6132 59 34.0722 59 35.6927ZM30.6667 51.9174H36.3333V37.7523H30.6667V51.9174ZM46.25 37.7523H37.75V51.9174H46.25V37.7523ZM53.3333 37.7523H47.6667V51.9174H53.3333V37.7523ZM57.5833 35.6927C57.5833 34.6119 56.9827 33.6402 56.0165 33.1572L43.1008 26.7078C42.4038 26.3267 41.5948 26.3267 40.9205 26.6965L27.9835 33.1572C27.0159 33.6402 26.4167 34.6105 26.4167 35.6927V36.3358H57.5833V35.6927Z",
    fill: "#00715D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_593_1052",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_593_1052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_593_1052",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGov);
export default __webpack_public_path__ + "static/media/Gov.107b98647154907248263e94149aa5f8.svg";
export { ForwardRef as ReactComponent };